import { createPortal } from 'react-dom';

interface RankingCategoria {
  categoria: string;
  cantidad: number;
  ultima_fecha?: string;
}

interface RankingReparacionesTicketProps {
  bus: { padron?: string; numero?: string; placa: string };
  ranking: RankingCategoria[];
  alertaActiva: boolean;
  reparacionesUltimos15Dias: number;
  categoriaMasFrecuenteReciente: string | null;
}

const RankingReparacionesTicket = ({
  bus,
  ranking,
  alertaActiva,
  reparacionesUltimos15Dias,
  categoriaMasFrecuenteReciente,
}: RankingReparacionesTicketProps) => {
  return createPortal(
    <div className="ticket-print-only">
      <p className="centro bold titulo">SISTEMA MANTSILA</p>
      <p className="centro">Ranking de Reparaciones</p>
      <hr />
      <p><span className="bold">Bus:</span> Padrón {bus.padron || bus.numero} - {bus.placa}</p>
      <p><span className="bold">Fecha:</span> {new Date().toLocaleDateString('es-PE')}</p>
      <hr />
      {alertaActiva && (
        <>
          <p className="centro bold">*** ALERTA: FALLAS FRECUENTES ***</p>
          <p>{reparacionesUltimos15Dias} reparaciones en los últimos 15 días</p>
          {categoriaMasFrecuenteReciente && (
            <p>Categoría más frecuente: {categoriaMasFrecuenteReciente.replace(/_/g, ' ')}</p>
          )}
          <hr />
        </>
      )}
      <p className="bold">Reparaciones por categoría:</p>
      {ranking.length === 0 && <p className="centro">Sin mantenimientos registrados</p>}
      {ranking.map((r) => (
        <div key={r.categoria} className="fila">
          <span>{r.categoria.replace(/_/g, ' ')}</span>
          <span>{r.cantidad}</span>
        </div>
      ))}
      <hr />
      <p className="centro" style={{ marginTop: '4mm' }}>Fin del reporte</p>
    </div>,
    document.body
  );
};

export default RankingReparacionesTicket;
